export default __webpack_public_path__ + "33b41b7.png";